import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M2.167 10A7.826 7.826 0 0110 2.167 7.826 7.826 0 0117.833 10 7.826 7.826 0 0110 17.833 7.826 7.826 0 012.167 10z" stroke="#54585D" /></svg>);